export interface LinkStatisticsTotals {
  clicks: number;
  clicksPercent: number;
  registrationsCount: number;
  registrationsPercent: number;
  fullKycCount: number;
  fullKycPercent: number;
  firstTimeFundsInCount: number;
  firstTimeFundsInPercent: number;
  startedTradingCount: number;
  startedTradingPercent: number;
  tradingAccountsActiveCount: number;
  tradingAccountsActivePercent: number;
  tradingAccountsInactiveCount: number;
  tradingAccountsInactivePercent: number;
}

export interface LinkStatisticsList {
  startDate: Date;
  endDate: Date;
  registrationsCount: number;
  fullKycCount: number;
  firstTimeFundsInCount: number;
  startedTradingCount: number;
  tradingAccountsActiveCount: number;
  tradingAccountsInactiveCount: number;
  clicks: number;
  shortCode?: string;
  partnershipCode?: string;
}

export interface LinkStatisticsReport {
  linkStatisticsTotals: LinkStatisticsTotals;
  linkStatisticsList: LinkStatisticsList[];
}

export enum PeriodType {
  Weekly = 1,
  Daily,
}
